import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ForgotCompanyCredentials } from '@pages/login-recovery-options/models/forgot-company-credentials.interface';
import { LoginRecoveryFacade } from '@pages/login-recovery-options/facades/login-recovery.facade';
import { BannerComponent, BannerType, fullEmailValidators, InputComponent, LargeButtonComponent } from '@kaseya-design-components';
import { TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ApplicationPath } from '@core/navigation/models/application-path.enum';

@Component({
  selector: 'itc-recover-company-name',
  templateUrl: 'recover-company-name.component.html',
  styleUrl: 'recover-company-name.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InputComponent, LargeButtonComponent, TranslatePipe, BannerComponent],
})
export class RecoverCompanyNameComponent {
  private readonly router = inject(Router);
  private readonly loginRecoveryFacade = inject(LoginRecoveryFacade);

  readonly loading = this.loginRecoveryFacade.loading;
  readonly errorMessageTranslationKey = this.loginRecoveryFacade.errorMessageTranslationKey;
  readonly recoveryForm = new FormGroup({
    userEmail: new FormControl('', { nonNullable: true, validators: fullEmailValidators }),
  });
  readonly BannerType = BannerType;

  recoverCredentials(): void {
    this.loginRecoveryFacade.recoverCredentialsByCompany(this.recoveryForm.value as ForgotCompanyCredentials);
  }

  backToLogin(): void {
    this.router.navigateByUrl(ApplicationPath.Login);
  }
}
